export default {
  text: 'Have an account? ',
  link: 'Log In',
};
